const apparelMen = document.querySelector('.apparel-buttons .men');
const apparelWomen = document.querySelector('.apparel-buttons .women');

apparelMen.addEventListener('click',function(e) {
	if(this.classList.contains('btn--primary')) return;
	this.classList.add('btn--primary');
	this.classList.remove('btn--secondary');
	apparelWomen.classList.remove('btn--primary');
	apparelWomen.classList.add('btn--secondary');
	for (let el of document.querySelectorAll('.apparel-women')) el.style.display = 'none'
	for (let el of document.querySelectorAll('.apparel-men')) el.style.display = 'flex'
})
apparelWomen.addEventListener('click',function(e) {
	if(this.classList.contains('btn--primary')) return;
	this.classList.add('btn--primary');
	this.classList.remove('btn--secondary');
	apparelMen.classList.remove('btn--primary');
	apparelMen.classList.add('btn--secondary');
	for (let el of document.querySelectorAll('.apparel-men')) el.style.display = 'none'
	for (let el of document.querySelectorAll('.apparel-women')) el.style.display = 'flex'	
})
